import { useContext, useState } from "react";
import { AuthContext } from "../../utils/context/auth.context.ts";
import { useTranslation } from "react-i18next";
import GEN_IMG from "./gen.jpg"
import TRAX_IMG from "./trax.jpg"
import PRO_IMG from "./project.png"
import WALLET_IMG from "./wallet.jpg"
import PRS_SALES from "./sales.component.js";
import PRS_INCOME from "./income.component.js";
import Balance from "../cont/balance.component.js";

export default function Home() {

  const { t } = useTranslation();
  const authContext = useContext(AuthContext)
  const { user, verify } = authContext;
  const [isCli] = useState(authContext.isCli());
  const bannerURL = `${process.env.REACT_APP_API_URL}/public/banners/`

  let BANNER_COMPONENT = () => <div className="row">
 <div className="col-lg-3 col-md-1 col-sm-0"></div>
    <div className="col-lg-6 col-md-10 col-sm-12">
      <div className="card mb-3">
        <img src={bannerURL + (isCli ? "home-cli.jpg": "home.jpg")} className="banner-home" alt="..." />
      </div>
    </div>
  </div>

  return (
    <div>
      <h1>ROCKAI</h1>
      <h3>{user?.name || ''}: {t(`users.role.${user?.cargo || ''}`)}</h3>
      {BANNER_COMPONENT()}
      {authContext.verify({ pathname: "/prs" }, "GET") ? <>
        <div className="row">
          <div className="col-md-6 col-sm-12"><PRS_SALES /></div>
          <div className="col-md-6 col-sm-12"><PRS_INCOME /></div>
        </div>
        <div>
          <Balance refresh={true} />
        </div>
      </>
        : null}
    </div>
  );
}